import { MouseEvent } from 'react';

import { isUuidV4 } from 'functions/isUuidV4';

import { KnmHistoryOperationsEnum } from '../../../../APIPackage/KnmModule/enums/KnmHistoryOperationsEnum';
import { IKnmHistoryItem } from '../../../../APIPackage/KnmModule/interfaces/IKnmHistoryItem';
import { knmLateChangedFields } from '../../constants/knmLateChangedFields';
import { uuidRegExp } from '../../../MainModule/constants/uuidRegExp';
import { doubleIdRegExp } from '../../../MainModule/constants/doubleIdRegExp';
import { HEADER_STICKED_HEIGHT } from '../../../../CorePackage/HeaderModule/constants/headerStickedHeight';

function getKeyByValue(map: Map<string, string>, value: string): string | undefined {
  const normalized = value.replace(/^\/+/, ''); // убираем ведущие /

  return [...map.entries()].find(([, val]) => val === normalized || val === value)?.[0];
}

export function getLateFiledLinkedName(
  lateChangesFields: IKnmHistoryItem[],
  lateFieldLinkPathMap: Map<string, string>,
  fieldName: string,
) {
  if (
    !lateChangesFields
      .flatMap(x => x?.changes)
      ?.find(x => x?.field.includes(fieldName) && x.operation !== KnmHistoryOperationsEnum.DELETE)
  ) {
    return null;
  }

  const makeLinkClickHandler = () => (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const scrollElementId = e.currentTarget.hash.replace('#', '');
    const scrollElement = document.getElementById(scrollElementId);

    if (scrollElement) {
      window.scrollTo({
        top: scrollElement.getBoundingClientRect().top + window.pageYOffset - HEADER_STICKED_HEIGHT - 5,
        behavior: 'smooth',
      });
    }
  };

  const uniqueFields: string[] = Array.from(
    new Set(
      lateChangesFields.flatMap((lateChange: IKnmHistoryItem) =>
        lateChange.changes
          .filter(
            change =>
              change.field.includes(fieldName) &&
              change.operation !== KnmHistoryOperationsEnum.DELETE &&
              (Array.isArray(change.newValue) ||
                typeof change.newValue === 'string' ||
                typeof change.newValue === 'boolean' ||
                typeof change.newValue === 'number') &&
              !isUuidV4(change.newValue),
          )
          .map(change => change.field),
      ),
    ),
  );

  if (uniqueFields?.length) {
    return (
      <>
        <div style={{ fontWeight: 800 }}>Cведения внесены не своевременно</div>
        {uniqueFields.map(changeField => {
          if (!changeField) {
            return;
          }

          const fieldPath = changeField
            .split('/')
            .map(item =>
              uuidRegExp.test(item) || (item !== '' && Number.isInteger(Number(item))) || doubleIdRegExp.test(item)
                ? '{id}'
                : item,
            )
            .join('/');

          const fieldTitle = knmLateChangedFields[fieldPath]?.name;
          const fieldLink = getKeyByValue(lateFieldLinkPathMap, changeField);

          if (!fieldTitle || !fieldLink) {
            return;
          }

          return (
            <div key={fieldLink}>
              <a href={`#${fieldLink}`} onClick={makeLinkClickHandler()}>
                {fieldTitle}
              </a>
            </div>
          );
        })}
      </>
    );
  }

  return <></>;
}
